import { List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';
import BaseList from 'records/BaseList';

import {
  CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
  CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
  CATER_CONCES_DESIGN_TEMPLATES_RESET_STATE,
} from 'actions/caterConcesDesignTemplates';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignTemplates(action.data),
    });
  },
  [CATER_CONCES_DESIGN_TEMPLATES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function caterConcesDesignTemplates(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
